export const animationValues = { 
    
    in: {
        opacity: 1,
        y: 0
    },

    out: {
        opacity: 0,
    y: '-3vh'
    }
}

export const transitionValues = {
    type: 'tween',
    ease: 'anticipate',
    transition: 'linear',
    duration: 0.8
}